import { defineStore } from "pinia";
import api from "@/services/api";

interface User {
  id: number;
  name: string;
  email: string;
  phone?: string;
  role: string;
}

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("auth_user") || "null") as User | null,
    token: localStorage.getItem("auth_token") as string | null,
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    isAdmin: (state) => state.user?.role === "admin",
  },

  actions: {
    async login(email: string, password: string, recaptcha_token = '') {
      const { data } = await api.post("/api/login", { email, password, recaptcha_token });
      this.token = data.token;
      this.user = data.user;
      localStorage.setItem("auth_token", data.token);
      localStorage.setItem("auth_user", JSON.stringify(data.user));
    },

    async register(name: string, email: string, password: string, recaptcha_token = '', phone = '', referral_code = '') {
      const { data } = await api.post("/api/register", { name, email, password, recaptcha_token, phone, referral_code });
      this.token = data.token;
      this.user = data.user;
      localStorage.setItem("auth_token", data.token);
      localStorage.setItem("auth_user", JSON.stringify(data.user));
    },

    async logout() {
      try {
        await api.post("/api/logout");
      } finally {
        this.token = null;
        this.user = null;
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
      }
    },
  },
});
